/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderVideoEnum } from './orderVideoEnum';
import { OrderStatusEnum } from './orderStatusEnum';
import { OrderTypeEnum } from './orderTypeEnum';


export interface OrderListRequest { 
    orderId?: number;
    branchId?: number;
    realEstateAgentId?: number;
    priceFrom?: number;
    priceTo?: number;
    locality?: string;
    types?: Array<OrderTypeEnum>;
    statuses?: Array<OrderStatusEnum>;
    properties?: Array<number>;
    video?: Array<OrderVideoEnum>;
    own?: boolean;
    limit?: number;
    offset?: number;
}

